// NPM imports
import React from "react";

// Components Imports
import FormField from "../PricebookItemEditor/FormField";
import PricingPreview from "../../PricingPreview";

// Internal Imports
import { manipulateCustomJSONTwo } from "./methods";
import { GRID } from "../../../constants";

// Destructuring
const { PRICEBOOK_COLUMNS } = GRID;

// Component
export default function FlatPriceEditor(props) {
  const { customJSON, data, fieldMapIndex } = props;
  const finalCustomJSON = manipulateCustomJSONTwo(
    customJSON,
    data,
    fieldMapIndex,
  );
  const price = data[fieldMapIndex[PRICEBOOK_COLUMNS.PRICE]];
  return (
    <div className="flatpriceeditor-wrapper">
      {finalCustomJSON.map(fields => (
        <FormField
          {...fields}
          isEdit={props.isEdit}
          currencySymbol={props.currencySymbol}
          key={fields.fld}
        />
      ))}
      <PricingPreview
        currencySymbol={props.currencySymbol}
        data={{
          type: "Flat Price",
          basePrice: (price && price.value) || 0,
        }} // custom PricingPreview props for flat price
        readOnly
      />
    </div>
  );
}
